import script from "./PaymentStep20676.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentStep20676.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentStep20676.vue?vue&type=style&index=0&id=6b4d6ee2&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b4d6ee2"]])

export default __exports__